import { SnMapClusterPoint } from '@lib/api';
import { COLORS } from '@lib/ui/theme';
import { GoogleMapClusterMarker } from '@lib/geo/google/map';

export class SnRegistryCameraClusterMarker extends GoogleMapClusterMarker {
  constructor(cluster: SnMapClusterPoint) {
    super(cluster, {
      style: {
        fillOpacity: 1,
        strokeOpacity: 0,
        scale: 1,
        fillColor: COLORS['light-blue-500'],
      },
      icon: {
        fontIcon: 'f03d',
        fontSet: 'fs',
      },
    });
  }
}
